import React, { useState, useEffect } from 'react';
import { BarChart3, QrCode, MousePointerClick, Lock } from 'lucide-react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

// Statistiques QR / visites des 30 derniers jours (plan Signature).
export default function StatsCard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [locked, setLocked] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user || user.role === 'MEMBER') return;
    api.get('/stats')
      .then(({ data }) => setStats(data))
      .catch((err) => {
        if (err.response?.data?.code === 'PLAN_UPGRADE_REQUIRED') setLocked(true);
      });
  }, [user]);

  if (user?.role === 'MEMBER') return null;
  if (!stats && !locked) return null;

  if (locked) {
    return (
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.9rem', color: 'var(--text-light)' }}>
          <BarChart3 size={16} />
          <span>
            <strong style={{ color: 'var(--text)' }}>Statistiques QR & visites</strong>
            {' '}— mesurez qui consulte vos chantiers (scans QR vs visites directes)
          </span>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.75rem' }}>
            <Lock size={11} /> plan Signature
          </span>
        </div>
      </div>
    );
  }

  const max = Math.max(1, ...stats.projects.map(p => p.total));

  return (
    <div className="card" style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        <h3 style={{ display: 'flex', alignItems: 'center', gap: 8, margin: 0 }}>
          <BarChart3 size={16} /> Visites des 30 derniers jours
        </h3>
        <div style={{ display: 'flex', gap: 14, fontSize: '0.85rem', color: 'var(--text-light)' }}>
          <span><QrCode size={13} style={{ verticalAlign: -2 }} /> {stats.totals.qr} scans QR</span>
          <span><MousePointerClick size={13} style={{ verticalAlign: -2 }} /> {stats.totals.direct} directes</span>
          <strong style={{ color: 'var(--text)' }}>{stats.totals.all} au total</strong>
        </div>
      </div>

      {stats.projects.length > 0 && (
        <>
          <button className="btn btn-sm" style={{ marginTop: 10 }} onClick={() => setOpen(!open)}>
            {open ? 'Masquer' : 'Détail par chantier'}
          </button>
          {open && (
            <div style={{ marginTop: 12 }}>
              {stats.projects.map(p => (
                <div key={p.projectId || 'landing'} style={{ marginBottom: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.82rem', marginBottom: 3 }}>
                    <span>{p.name}</span>
                    <span style={{ color: 'var(--text-light)' }}>{p.qr} QR · {p.direct} directes</span>
                  </div>
                  <div style={{ height: 6, borderRadius: 99, background: '#f1f5f9', overflow: 'hidden', display: 'flex' }}>
                    <div style={{ width: `${(p.qr / max) * 100}%`, background: '#2563eb' }} />
                    <div style={{ width: `${(p.direct / max) * 100}%`, background: '#93c5fd' }} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
